import * as Yup from "yup"
import { RoleFormParam } from "./roles.type"
import { Status } from "src/graphql/quark/quark.type"

export const roleInitialValues = {
  name: "",
  status: Status.Active,
  permissions: []
}

export const roleValidationSchema: Yup.ObjectSchema<RoleFormParam> = Yup.object().shape({
  id: Yup.string().nullable().optional(),
  name: Yup.string().required("Name is required."),
  status: Yup.string().oneOf(Object.values(Status)).required("Status is required."),
  permissions: Yup.array()
    .of(Yup.string().required("Permissions is required."))
    .min(1, "Permissions is required.")
    .required()
})
